<template>
  <div>
    <div class="main-content">
      <div id="boxloading"></div>
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <router-link tag="li" :to="{ name: 'user'}">
              <a>ユーザー</a>
            </router-link>
            <li class="active">ユーザー編集</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>ユーザー編集</h3>
          </div>
          <a href="#question" id="xacnhan" data-toggle="modal" style="display:none">show</a>
        </div><!-- /.page-header -->
        <div class="page-content register_user">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
            <div class="alert alert-danger" v-if="errorMessageLogs!==''">
              {{ errorMessageLogs }}
            </div>
            <div class="alert alert-success" v-if="message">
              {{ message }}
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-2 center userav">
                <div class="col-xs-12 col-sm-12">
                  <span class="profile-picture">
                    <img id="user_avatar" height="150" widht="150" class="thumbnail inline no-margin-bottom" alt="user-avatar" :src="showAvatar(userInfor.thumbnail)" style="width:150px; height:150px; overflow:auto" />
                  </span>
                </div>
                <div class="col-xs-12 col-sm-12">
                  <label for="file_user_avatar" class="btn-upload" style="background:black;color:white;padding:5px 15px;margin-top:10px;cursor: pointer;">
                    画像ファイルを選択
                    <input type="file" name="avatar" style="display:none" id="file_user_avatar" accept='image/png'>
                  </label>
                </div>
                <span id="fileimg_error" class="error_m"></span>
              </div><!-- /.col -->
              <div class="col-xs-12 col-sm-10">
                <div class="profile-user-info">
                  <div class="alert alert-danger" v-if="sameUser">
                    <p>(※)の権限は変更できません。変更が必要な場合は、別の管理者に依頼してください。</p>
                  </div>
                </div>
                <div class="profile-user-info">
                  <div class="profile-info-row">
                    <div class="profile-info-id">ユーザーID</div>
                    <div class="profile-info-value">
                      <input type="text" disabled class="form-control input-sm" placeholder="ユーザーID" v-model="userInfor.userId">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザー名（登録名） <font class="input-required">※必須</font></div>
                    <div class="profile-info-value">
                      <span id="name_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="name" placeholder="ユーザー名" v-model="userInfor.name" @blur="validateBeforeSubmit(2)">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザー名（ふりがな）</div>
                    <div class="profile-info-value">
                      <span id="furigana_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="furigana" placeholder="ふりがな" v-model="userInfor.furigana" @blur="validateBeforeSubmit(3)">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">メールアドレス</div>
                    <div class="profile-info-value">
                      <span id="mailaddress_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="mailaddress" placeholder="example@example.com" v-model="userInfor.email" @blur="validateBeforeSubmit(4)">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">暗証番号</div>
                    <div class="profile-info-value">
                      <span id="passcode_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="passcode" placeholder="0000" v-model="userInfor.passCode" @blur="validateBeforeSubmit(5)">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">組織管理権限<span class="red" v-if="sameUser">(※)</span></div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.isAdmin" :disabled="sameUser">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲート設定権限<span class="red" v-if="sameUser">(※)</span></div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.isPhoneAdmin" :disabled="sameUser">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">鍵共有権限<span class="red" v-if="sameUser">(※)</span></div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.shareKeyBeValid" :disabled="sameUser">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ステータス<span class="red" v-if="sameUser">(※)</span></div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.isValid" :disabled="sameUser">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ログインパスワード変更<span class="red" v-if="sameUser">(※)</span></div>
                    <div class="profile-info-value">
                      <span class="lblPassword">
                        新しいパスワード
                      </span>
                      <label class="clearfix cusrow">
                        <span id="password_error" class="error_m"></span>
                        <input id="password" autocomplete="new-password" :disabled="sameUser" placeholder="パスワード" name="password" type="password" class="form-control input-sm" v-model="credentials.newPassword" @blur="validateBeforeSubmit(0)">
                      </label>
                      <span class="newpassword-showhide">
                        <span class="show-password" @click="showhidePassword('password' , 'show-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_off.png" width="30"></span>
                        <span class="hide-password" @click="showhidePassword('password' , 'hide-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_on.png" width="30"></span>
                      </span>
                      <br>
                      <span class="lblPassword">
                        新しいパスワード再入力
                      </span>
                      <label class="clearfix cusrow">
                        <span id="repassword_error" class="error_m"></span>
                        <input id="repassword" :disabled="sameUser" autocomplete="new-password" placeholder="パスワード" name="password" type="password" class="form-control input-sm" v-model="credentials.rePassword" @blur="validateBeforeSubmit(1)">
                      </label>
                      <span class="repassword-showhide">
                        <span class="show-password" @click="showhidePassword('repassword' , 'show-password' , 'repassword-showhide')"><img src="../../../static/img/eye_off.png" width="30"></span>
                        <span class="hide-password" @click="showhidePassword('repassword' , 'hide-password' , 'repassword-showhide')"><img src="../../../static/img/eye_on.png" width="30"></span>
                      </span>
                      <div class="warringu">
                        ログインパスワードは英大文字、英小文字、数字を組み合わせた8文字以上64文字以内で設定してください。
                      </div>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">SMS認証</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" :disabled ="(isMfa === 'false')" v-model="userInfor.isMfaSms">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">電話番号</div>
                    <div class="profile-info-value">
                      <span id="phonenumber_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm input" id="phonenumber" placeholder="" :disabled ="!isSMS" v-model="userInfor.phoneNumber" @blur="validateBeforeSubmit(8)">
                      <p style="margin-top:10px">0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。</p>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">備考.1</div>
                    <div class="profile-info-value">
                      <span id="option1_error" class="error_m"></span>
                      <textarea class="form-control" id="option1" placeholder="備考.1" v-model="userInfor.option1" @blur="validateBeforeSubmit(6)"></textarea>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">備考.2</div>
                    <div class="profile-info-value">
                      <span id="option2_error" class="error_m"></span>
                      <textarea class="form-control" id="option2" placeholder="備考.2" v-model="userInfor.option2" @blur="validateBeforeSubmit(7)"></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <div class="action_box">
                      <router-link :to="{ name: 'user'}" class="btn cancel_bottom">
                        キャンセル
                      </router-link>
                      <!-- :disabled="!isEnabledSave" -->
                      <button class="btn btn-info save_group_bottom" type="button" @click="submitEditUser">
                        保存
                      </button>
                    </div>
                  </div>
                </div>
              </div><!-- /.col -->
            </div>
            <div id="accordion" class="accordion-style1 panel-group">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <h4 class="panel-title">
                    <a class="accordion-toggle" data-toggle="collapse" href="#phone" aria-expanded="true"  @click="getDataPhone()">
                      <i class="ace-icon fa fa-angle-right bigger-110" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                      &nbsp;スマートフォン
                    </a>
                  </h4>
                </div>
                <div class="panel-collapse collapse" id="phone">
                  <div class="panel-body">
                    <table style="min-width:100%" class="table table-striped table-bordered table-hover dataTable">
                      <thead>
                        <tr>
                          <th>スマートフォンID</th>
                          <th>端末名</th>
                          <th class="center">ステータス</th>
                          <th class="center">登録日</th>
                        </tr>
                      </thead>
                      <tbody v-if="listphones!=null">
                        <template v-for="(item, index) in listphones">
                          <tr :key="index">
                            <td>{{item.phoneId}}</td>
                            <td>{{item.model}}</td>
                            <td class="center">{{item.status}}</td>
                            <td class="center">{{converDate(item.registered)}}</td>
                          </tr>
                        </template>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="4">データーはありません</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="row pd-t-10">
                      <div class="col-xs-12">
                        <div class="dataTables_paginate paging_simple_numbers" v-if="pagesPhone>0">
                          <paginate
                            :page-count="pagesPhone"
                            :page-range="3"
                            :margin-pages="2"
                            :click-handler="handleCurrentChangePhone"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :container-class="'pagination'"
                            :page-class="'page-item'">
                          </paginate>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel panel-default">
                <div class="panel-heading">
                  <h4 class="panel-title">
                    <a class="accordion-toggle" data-toggle="collapse" href="#pcode"  @click="getDataPcode()">
                      <i class="bigger-110 ace-icon fa fa-angle-right" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                      &nbsp;個人コード
                    </a>
                  </h4>
                </div>
                <div class="panel-collapse collapse" id="pcode" aria-expanded="true">
                  <div class="panel-body">
                    <table style="min-width:100%" class="table table-striped table-bordered table-hover dataTable">
                      <thead>
                        <tr>
                          <th class="center" v-if="listPcode!=null" style="width:50px!important">
                            <label class="pos-rel">
                              <input type="checkbox" class="ace" v-model="selectAllPcode">
                              <span class="lbl"></span>
                            </label>
                          </th>
                          <th>個人コードID</th>
                          <th class="center">個人コード種別</th>
                          <th class="center">ステータス</th>
                          <th class="center">登録日</th>
                        </tr>
                      </thead>
                      <tbody v-if="listPcode != null">
                        <template v-for="(item, index) in listPcode">
                          <tr v-bind:class="{'selected': rowSelectedPcode(item.pCodeId)}" :id="item.pCodeId" :key="index">
                            <td class="center">
                              <label class="pos-rel">
                                <input type="checkbox" class="ace" :value="item.pCodeId" v-model="selectedPcodeId">
                                <span class="lbl"></span>
                              </label>
                            </td>
                            <td>{{item.pCodeId}}</td>
                            <td class="center">{{item.type}}</td>
                            <td class="center">
                              <span v-if="item.isValid">有効</span>
                              <span v-else >無効</span>
                            </td>
                            <td class="center">{{converDate(item.registered)}}</td>
                          </tr>
                        </template>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="4">データーはありません</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="row pd-t-10">
                      <div class="col-xs-12">
                        <div class="dataTables_paginate paging_simple_numbers" v-if="pagesPcode>0">
                          <paginate
                            :page-count="pagesPcode"
                            :page-range="3"
                            :margin-pages="2"
                            :click-handler="handleCurrentChangePcode"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :container-class="'pagination'"
                            :page-class="'page-item'">
                          </paginate>
                        </div>
                      </div>
                    </div>
                    <button class="btn-cus btn-right btn-add" type="button" @click="addPcode(userInfor.userId)">
                    個人コードの関連付けを追加
                    </button>
                    <a class="btn-cus btn-right btn-delete" href="#processPcode" data-toggle="modal" @click="resetStatus()">チェックした個人コードの関連付け解除</a>
                  </div>
                </div>
              </div>
              <div class="panel panel-default">
                <div class="panel-heading">
                  <h4 class="panel-title">
                    <a class="accordion-toggle" data-toggle="collapse" href="#gatepassage"  @click="getDataGate()">
                      <i class="bigger-110 ace-icon fa fa-angle-right" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                      &nbsp;期限付きゲート
                    </a>
                  </h4>
                </div>
                <div class="panel-collapse collapse" id="gatepassage" aria-expanded="true">
                  <div class="panel-body">
                    <table style="min-width:100%" class="table table-striped table-bordered table-hover dataTable">
                      <thead>
                        <tr>
                          <th class="center" v-if="loopListGatePassages!=null" style="width:50px!important">
                            <label class="pos-rel">
                              <input type="checkbox" class="ace" v-model="selectAllGate">
                              <span class="lbl"></span>
                            </label>
                          </th>
                          <th >ゲートID</th>
                          <th>ゲート名</th>
                          <th class="center">開始日時</th>
                          <th class="center">終了日時</th>
                        </tr>
                      </thead>
                      <tbody v-if="loopListGatePassages!=null">
                        <template v-for="(item, index) in loopListGatePassages">
                          <tr v-bind:class="{'selected': rowSelectedPassage(item.passageId)}" :id="item.passageId" :key="index" v-if="item.gateId.isValid">
                            <td class="center">
                              <label class="pos-rel">
                                <input type="checkbox" class="ace" :value="item.passageId" v-model="selectedPassageId">
                                <span class="lbl"></span>
                              </label>
                            </td>
                            <td>{{item.gateId.gateId}}</td>
                            <td>{{item.gateId.gateName}}</td>
                            <td class="center">{{converDate(item.notBefore)}}</td>
                            <td class="center">{{converDate(item.notAfter)}}</td>
                          </tr>
                        </template>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="4">{{messageGate}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="row pd-t-10">
                      <div class="col-xs-12">
                        <div class="dataTables_paginate paging_simple_numbers" v-if="pagesGate>0">
                          <paginate
                            :page-count="pagesGate"
                            :page-range="3"
                            :margin-pages="2"
                            :click-handler="handleCurrentChangeGate"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :container-class="'pagination'"
                            :page-class="'page-item'">
                          </paginate>
                        </div>
                      </div>
                    </div>
                    <button class="btn-cus btn-right btn-add" type="button" @click="addGatePassage(userInfor.userId)">ゲートの関連付けを追加
                    </button>
                    <a class="btn-cus btn-right btn-delete" href="#processGate" data-toggle="modal" @click="resetStatus()">チェックしたゲートの関連付け解除</a>
                  </div>
                </div>
              </div>
              <div class="panel panel-default">
                <div class="panel-heading">
                  <h4 class="panel-title">
                    <a class="accordion-toggle" data-toggle="collapse" href="#Passages" @click="getDataGateGroup()">
                      <i class="bigger-110 ace-icon fa fa-angle-right" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                      &nbsp;解錠可能ゲート
                    </a>
                  </h4>
                </div>
                <div class="panel-collapse collapse" id="Passages" aria-expanded="true">
                  <div class="panel-body">
                    <table style="min-width:100%" class="table table-striped table-bordered table-hover dataTable">
                      <thead>
                        <tr>
                          <th>ゲートID</th>
                          <th>ゲート名</th>
                          <th>ゲートグループ</th>
                        </tr>
                      </thead>
                      <tbody  v-if="listGroupPassages!=null && listGroupPassages.length > 0">
                        <template v-for="(item, index) in listGroupPassages">
                          <tr :key="index" v-if="item.gate.isValid">
                            <td>{{item.gate.gateId}}</td>
                            <td>{{item.gate.name}}</td>
                            <td>{{item.group.name}}</td>
                          </tr>
                        </template>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="3">{{messageGroup}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="row pd-t-10">
                      <div class="col-xs-12">
                        <div class="dataTables_paginate paging_simple_numbers" v-if="pagesPassage>0">
                          <paginate
                            :page-count="pagesPassage"
                            :page-range="3"
                            :margin-pages="2"
                            :click-handler="handleCurrentChangePassage"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :container-class="'pagination'"
                            :page-class="'page-item'">
                          </paginate>
                        </div>
                      </div>
                    </div>
                    <button class="btn-cus btn-right btn-add" type="button" @click="addPassage(userInfor.userId)">
                    ゲートグループの関連付けを追加
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <div id="processPcode" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">関連付け解除</h3>
          </div>
          <div class="modal-body">
            <span class="progress-question">このユーザーとの関連付けを解除しますか？</span>
            <div class="progress" v-bind:class="{'progress-striped':!success , active:!success ,hide:!success}">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <span class="success-label" v-if="successPcode>0">{{countPcode}}件中{{successPcode}}件を解除しました。</span>
            <div v-if="errorMessage.length>0">
            <span class="error-box-title">解除失敗</span>
            <div class="error-box">
              <template v-for="item in errorMessage">
                <p v-html="item" :key="item"></p>
              </template>
            </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="deleteRelationPcode()">実行</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <div id="processGate" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">関連付け解除</h3>
          </div>
          <div class="modal-body">
            <span class="progress-question">このゲートとの関連付けを解除しますか？</span>
            <div class="progress" v-bind:class="{'progress-striped':!success , active:!success , hide:!success}">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <span class="success-label" v-if="successGate>0">{{countGate}}件中{{successGate}}件を削除しました。</span>
            <div v-if="errorMessage.length>0">
            <span class="error-box-title">解除失敗</span>
            <div class="error-box">
              <template v-for="item in errorMessage">
                <p v-html="item" :key="item"></p>
              </template>
            </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="deleteRelationGate()">実行</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <!-- プロフィールModal -->
    <div id="question" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div>
              編集したユーザーのメールアドレスへ通知メールを送信しますか？
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success" style="width:100px" data-dismiss="modal" @click="yesChoice()">送信する</button>
            <button class="btn btn-sm" style="width:100px" data-dismiss="modal" @click="noChoice()">送信しない</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'
export default {
  data () {
    return {
      listphones: null,
      listPcode: null,
      listPassage: null,
      listGatePassages: null,
      loopListGatePassages: null,
      listGroupPassages: [],
      tempGroupPassages: null,
      listrelationsGateGroup: null,
      credentials: {
        newPassword: '',
        rePassword: ''
      },
      userInfor: {
        userId: '',
        name: '',
        furigana: '',
        email: '',
        thumbnail: '',
        passCode: '',
        isMfaSms: false,
        phoneNumber: '',
        isAdmin: false,
        isPhoneAdmin: false,
        shareKeyBeValid: false,
        option1: '',
        option2: '',
        isValid: false,
        isSendEmail: false
      },
      pCodeConfigTypes: null,
      pagesPhone: 0,
      pagesPcode: 0,
      pagesPassage: 0,
      pagesGate: 0,
      listQuery: {
        currPage: 1,
        currPagePcode: 1,
        currPagePassage: 1,
        currPageGate: 1
      },
      flag: 0,
      flagP: false,
      base64: '',
      sucessStatus: false,
      error: '',
      selectedPcodeId: [],
      selectedPassageId: [],
      message: '',
      isDisabled: false,
      progress: 0,
      success: false,
      loading: false,
      errorMessage: [],
      successPcode: 0,
      successGate: 0,
      errorName: '',
      countPcode: 0,
      currentTime: '',
      countGate: 0,
      exeCountPcode: 0,
      exeCountGate: 0,
      percent: 0,
      totalGateP: 0,
      extGateInfo: 0,
      messageGate: 'データー取得中',
      messageGroup: 'データー取得中',
      loopData: null,
      exeGateGroup: 0,
      exeGetInforGate: 0,
      exeGetInforGroup: 0,
      totalGateGroup: 0,
      totalGate: 0,
      sameUser: false,
      imgWidth: 0,
      imgHeight: 0,
      errorMessageLogs: '',
      anwser: false,
      fileTmp: '',
      isMfa: false,
      isSMS: false
      // isEnabledSave: false // IF true: Enabled button 保存, false: disabled button 保存
    }
  },
  watch: {
    'userInfor.isMfaSms': function (newVal, oldVal) {
      $('#phonenumber_error.error_m').html('')
      $('.input').removeClass('error')
      if (newVal === false) {
        this.isSMS = false
      } else {
        this.isSMS = true
      }
    },
    'progress': 'checkProgress',
    exeCountPcode: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countPcode) {
        vm.deletePcode(this.selectedPcodeId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countPcode) {
        vm.getInforPcode(this.userInfor.userId)
      }
    },
    exeCountGate: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countGate) {
        vm.deleteGate(this.selectedPassageId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countGate) {
        vm.getInforGatePassage(this.userInfor.userId)
      }
    },
    extGateInfo: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < (vm.totalGateP)) {
        vm.getInforGateP(vm.listGatePassages[newVal].gateId, newVal)
      } else if (newVal > 0 && newVal === (vm.totalGateP)) {
        vm.loopListGatePassages = vm.listGatePassages
        vm.loading = false
      }
    },
    exeGateGroup: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalGateGroup) {
        vm.getGateGroup(vm.tempGroupPassages[newVal].groupId)
      } else if (newVal > 0 && newVal === vm.totalGateGroup) {
        vm.totalGate = vm.listGroupPassages.length
        if (vm.totalGate === 0) {
          this.message = 'データーはありません'
        }
        this.loading = false
      } else {
        this.loading = false
        this.message = 'データーはありません'
      }
    },
    exeGetInforGate: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < (vm.totalGate)) {
        vm.getInforGate(vm.listGroupPassages[newVal].gateId, newVal)
      } else if (newVal > 0 && newVal === (vm.totalGate)) {
        vm.getInforGroup(vm.listGroupPassages[0].groupId, 0)
      }
    },
    exeGetInforGroup: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < (vm.totalGate)) {
        vm.getInforGroup(vm.listGroupPassages[newVal].groupId, newVal)
      } else if (newVal > 0 && newVal === (vm.totalGate)) {
        vm.loopData = vm.listGroupPassages
        vm.loading = false
      }
    }
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAllPcode: {
      get: function () {
        return this.listPcode ? this.selectedPcodeId.length === this.listPcode.length : false
      },
      set: function (value) {
        var selectedPcodeId = []
        if (value) {
          this.listPcode.forEach(function (item) {
            selectedPcodeId.push(item.pCodeId)
          })
        }
        this.selectedPcodeId = selectedPcodeId
      }
    },
    selectAllGate: {
      get: function () {
        return this.listPassage ? this.selectedPassageId.length === this.listPassage.length : false
      },
      set: function (value) {
        var selectedPassageId = []
        if (value) {
          this.listPassage.forEach(function (item) {
            selectedPassageId.push(item.passageId)
          })
        }
        this.selectedPassageId = selectedPassageId
      }
    }
  },
  created () {
    var vm = this
    vm.getInforUser()
  },
  mounted () {
    var vm = this
    vm.isMfa = localStorage.isMfa
    vm.currentTime = vm.converTimestamp(Date())
    // $('input:file').change(function () {
    //   var file = document.querySelector('input[type="file"]').files[0]
    //   vm.getBase64(file)
    //   vm.converImgtpBase64(file)
    // })
    var _URL = window.URL
    $('#file_user_avatar').change(function (e) {
      var img
      var file = document.querySelector('input[type="file"]').files[0]
      vm.fileTmp = file
      if ((file = this.files[0])) {
        img = new Image()
        img.src = _URL.createObjectURL(file)
        img.onload = function () {
          vm.imgWidth = this.width
          vm.imgHeight = this.height
          vm.validateBeforeSubmit(8)
        }
      }
    })
  },
  methods: {
    yesChoice () {
      this.userInfor.isSendEmail = true
      this.loading = true
      if (this.credentials.newPassword !== null && this.credentials.newPassword !== '') {
        this.changePassword(this.userInfor.userId)
      } else {
        this.editUser()
      }
    },
    noChoice () {
      this.userInfor.isSendEmail = false
      this.loading = true
      if (this.credentials.newPassword !== null && this.credentials.newPassword !== '') {
        this.changePassword(this.userInfor.userId)
      } else {
        this.editUser()
      }
    },
    showhidePassword (passwordId, classname, buttonname) {
      if (classname === 'show-password') {
        $('#' + passwordId).attr('type', 'text')
        $('.' + buttonname).find('.show-password').hide()
        $('.' + buttonname).find('.hide-password').show()
      } else {
        $('#' + passwordId).attr('type', 'password')
        $('.' + buttonname).find('.hide-password').hide()
        $('.' + buttonname).find('.show-password').show()
      }
    },
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    checkProgress () {
      if (Math.round(this.progress) === 100) {
        this.success = true
        this.selectedPcodeId = []
        this.selectedPassageId = []
      }
    },
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('このユーザーとの関連付けを解除しますか？')
      this.progress = 0
      this.success = false
      this.isDisabled = false
      this.errorMessage = []
      this.successPcode = 0
      this.countPcode = 0
      this.successGate = 0
      this.countGate = 0
      this.exeCountGate = 0
      this.exeCountPcode = 0
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD HH:mm')
    },
    getDataPhone () {
      if (this.listphones === null) {
        this.getInforPhone(this.userInfor.userId)
      }
    },
    getDataPcode () {
      if (this.listPcode === null) {
        this.getInforPcode(this.userInfor.userId)
      }
    },
    getDataGate () {
      if (this.loopListGatePassages === null) {
        this.getInforGatePassage(this.userInfor.userId)
      }
    },
    getDataGateGroup () {
      if (this.loopData === null) {
        this.getInforGroupPassage(this.userInfor.userId)
      }
    },
    // ゲート取得
    getInforGate (gateId, i) {
      var vm = this
      this.$http.get(Config.GATES_LIST_API + '?gateId=' + encodeURIComponent(gateId) + '&isValid=true')
        .then(response => {
          vm.listGroupPassages[i].gateId = response.body.gates[0]
          vm.exeGetInforGate++
        })
        .catch((error) => {
          vm.exeGetInforGate++
          console.log(error)
        })
    },
    // ゲートグループ取得
    getInforGroup (groupId, i) {
      var vm = this
      this.$http.get(Config.GROUPS_LIST_API + '?groupId=' + encodeURIComponent(groupId))
        .then(response => {
          vm.listGroupPassages[i].groupId = response.body.groups[0]
          vm.exeGetInforGroup++
        })
        .catch((error) => {
          vm.exeGetInforGroup++
          console.log(error)
        })
    },
    // ゲート&グループ連関取得
    getGateGroup (groupId) {
      var vm = this
      this.$http.get(Config.RELATION_GATE_GROUP_API + '?groupId=' + encodeURIComponent(groupId) + '&embed=group,gate')
        .then(response => {
          vm.listrelationsGateGroup = response.body.relationsGateGroup
          for (var i = 0; i < vm.listrelationsGateGroup.length; i++) {
            const result = vm.listGroupPassages.find(({ gateId }) => gateId === vm.listrelationsGateGroup[i].gateId)
            if (result === undefined) {
              vm.listGroupPassages.push(vm.listrelationsGateGroup[i])
            }
          }
          vm.exeGateGroup++
        })
        .catch((error) => {
          vm.exeGateGroup++
          console.log(error)
        })
    },
    // ゲートグループ通行権限取得
    getInforGroupPassage (userId) {
      var vm = this
      vm.exeGateGroup = 0
      vm.exeGetInforGroup = 0
      vm.exeGetInforGate = 0
      this.loading = true
      this.$http.get(Config.GROUPS_PASSAGE_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          if (response.body.maxRecords > 0) {
            vm.tempGroupPassages = response.body.groupPassages
            vm.totalGateGroup = vm.tempGroupPassages.length
            vm.getGateGroup(vm.tempGroupPassages[0].groupId)
          }
        })
        .catch((error) => {
          this.loading = false
          console.log(error)
          this.messageGroup = 'データーはありません'
        })
    },
    handleCurrentChangePassage (val) {
      this.listQuery.currPagePassage = val
      this.getInforGroupPassage(this.userInfor.userId)
    },
    // ゲート取得
    getInforGateP (gateId, i) {
      var vm = this
      this.$http.get(Config.GATES_LIST_API + '?gateId=' + encodeURIComponent(gateId) + '&isValid=true')
        .then(response => {
          vm.extGateInfo++
          vm.listGatePassages[i].gateId = response.body.gates[0]
        })
        .catch((error) => {
          vm.extGateInfo++
          console.log(error)
        })
    },
    handleCurrentChangeGate (val) {
      this.selectedPassageId = []
      this.listQuery.currPageGate = val
      this.getInforGatePassage(this.userInfor.userId)
    },
    // 期限付きゲート
    getInforGatePassage (userId) {
      var vm = this
      vm.loading = true
      vm.extGateInfo = 0
      this.$http.get(Config.GATES_PASSAGE_API + '?userId=' + encodeURIComponent(userId) + '&notBefore=' + vm.currentTime + '&limit=25&page=' + this.listQuery.currPageGate)
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.listPassage = response.body.passages
            this.pagesGate = Math.ceil((response.body.maxRecords) / 25)
            vm.listGatePassages = response.body.passages
            vm.totalGateP = vm.listGatePassages.length
            vm.getInforGateP(vm.listGatePassages[0].gateId, 0)
          } else {
            this.loopListGatePassages = null
          }
        })
        .catch((error) => {
          this.loopListGatePassages = null
          this.loading = false
          this.pagesGate = 0
          this.messageGate = 'データーはありません'
          console.log(error)
        })
    },
    // ページネーションチェンジ
    handleCurrentChangePhone (val) {
      this.listQuery.currPage = val
      this.getInforPhone(this.userInfor.userId)
    },
    // スマートフォン取得
    getInforPhone (userId) {
      var vm = this
      this.$http.get(Config.PHONES_LIST_API + '?userId=' + encodeURIComponent(userId) + '&limit=25&page=' + this.listQuery.currPage + '&isValid=true')
        .then(response => {
          console.log(response)
          if (response.body.maxRecords > 0) {
            this.pagesPhone = Math.ceil((response.body.maxRecords) / 25)
            vm.listphones = response.body.phones
          } else {
            vm.pagesPhone = 0
            vm.listphones = null
          }
        })
        .catch((error) => {
          vm.pagesPhone = 0
          console.log(error)
          vm.listphones = null
        })
    },
    // NFC読み取り設定種別取得
    getTypeInfo (type, i) {
      var vm = this
      if (type === 0) {
        vm.listPcode[i].type = 'NFCカード'
      } else {
        vm.listPcode[i].type = 'テンキー入力'
      }
    },
    // 行にチェックする
    rowSelectedPcode (pcodeId) {
      if (jQuery.inArray(pcodeId, this.selectedPcodeId) !== -1) {
        return true
      } else {
        return false
      }
    },
    rowSelectedPassage (passageId) {
      if (jQuery.inArray(passageId, this.selectedPassageId) !== -1) {
        return true
      } else {
        return false
      }
    },
    // ページネーションチェンジ
    handleCurrentChangePcode (val) {
      this.selectedPcodeId = []
      this.listQuery.currPagePcode = val
      this.getInforPcode(this.userInfor.userId)
    },
    // 個人コード取得
    getInforPcode (userId) {
      var vm = this
      this.$http.get(Config.PCODE_LIST_API + '?userId=' + encodeURIComponent(userId) + '&limit=25&page=' + this.listQuery.currPagePcode)
        .then(response => {
          if (response.body.maxRecords > 0) {
            vm.pagesPcode = Math.ceil((response.body.maxRecords) / 25)
            vm.listPcode = response.body.pCodes
            for (var i = 0; i < vm.listPcode.length; i++) {
              vm.getTypeInfo(vm.listPcode[i].type, i)
            }
          } else {
            vm.listPcode = null
            vm.pagesPcode = 0
          }
        })
        .catch((error) => {
          console.log(error)
          vm.listPcode = null
          vm.pagesPcode = 0
        })
    },
    deletePcode (pCodeId, percent, i) {
      this.$http.put(Config.PCODE_LIST_API + '/' + encodeURIComponent(pCodeId), {userId: ''})
        .then(response => {
          this.progress += percent
          this.successPcode += 1
          this.exeCountPcode++
        })
        .catch((error) => {
          this.progress += percent
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorName = ''
              } else {
                this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 403:
              this.errorName = '個人コード情報の削除権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = pCodeId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          this.exeCountPcode++
        })
    },
    deleteRelationPcode () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedPcodeId.length > 0) {
        vm.countPcode = vm.selectedPcodeId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / vm.selectedPcodeId.length)
        vm.deletePcode(vm.selectedPcodeId[0], vm.percent, 0)
      } else {
        alert('少なくても個人コードを１つ選んでください。')
      }
    },
    deleteGate (passageId, percent, i) {
      this.$http.delete(Config.GATES_PASSAGE_API + '/' + encodeURIComponent(passageId))
        .then(response => {
          this.progress += percent
          this.successGate += 1
          this.exeCountGate++
        })
        .catch((error) => {
          this.progress += percent
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorName = ''
              } else {
                this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 403:
              this.errorName = '期間指定の通行権限の削除権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = passageId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          this.exeCountGate++
        })
    },
    deleteRelationGate () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedPassageId.length > 0) {
        vm.countGate = vm.selectedPassageId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / vm.selectedPassageId.length)
        vm.deleteGate(vm.selectedPassageId[0], vm.percent, 0)
      } else {
        alert('少なくてもゲートを１つ選んでください。')
      }
    },
    showAvatar (imgdata) {
      return 'data:image/png;base64,' + imgdata
    },
    getInforUser () {
      var vm = this
      vm.errorMessageLogs = ''
      var data = this.$route.query
      if (data.id === localStorage.userProfileId) {
        vm.sameUser = true
      }
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(data.id))
        .then(response => {
          console.log(response)
          vm.userInfor.userId = response.body.users[0].userId
          vm.userInfor.name = response.body.users[0].name
          vm.userInfor.furigana = response.body.users[0].furigana
          vm.userInfor.email = response.body.users[0].email
          vm.userInfor.passCode = response.body.users[0].passCode
          vm.userInfor.isMfaSms = response.body.users[0].isMfaSms
          vm.userInfor.phoneNumber = response.body.users[0].phoneNumber
          vm.userInfor.phoneNumber = vm.userInfor.phoneNumber.replace('+81', '0')
          vm.userInfor.isAdmin = response.body.users[0].isAdmin
          vm.userInfor.isPhoneAdmin = response.body.users[0].isPhoneAdmin
          vm.userInfor.shareKeyBeValid = response.body.users[0].shareKeyBeValid
          vm.userInfor.thumbnail = response.body.users[0].thumbnail
          vm.userInfor.option1 = response.body.users[0].option1
          vm.userInfor.option2 = response.body.users[0].option2
          vm.userInfor.isValid = response.body.users[0].isValid
          if (vm.userInfor.isMfaSms === true) {
            this.isSMS = true
          }
          vm.validateBeforeSubmit(2)
        })
        .catch(error => {
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessageLogs = ''
              } else {
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    getBase64 (file) {
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function () {
        document.getElementById('user_avatar').setAttribute(
          'src', reader.result
        )
      }
      reader.onerror = function (error) {
        console.log('Error: ', error)
      }
    },
    converImgtpBase64 (file) {
      var vm = this
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function () {
        var str = reader.result
        var imgurl = str.replace(/^data:image\/[a-z]+;base64,/, '')
        vm.userInfor.thumbnail = imgurl
      }
    },
    addPcode (userId) {
      this.$router.push({name: 'userpcodeadd', query: { id: userId }})
    },
    addPassage (userId) {
      this.$router.push({name: 'userpassageadd', query: { id: userId }})
    },
    addGatePassage (userId) {
      this.$router.push({name: 'usergateadd', query: { id: userId }})
    },
    validateBeforeSubmit (index) {
      var isValid = true
      var vm = this
      if (this.credentials.newPassword !== null && this.credentials.newPassword !== '') {
        if (!this.credentials.newPassword.match('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*).{8,64}$')) {
          if (index === -1 || index === 0) {
            $('#password_error').html('ログインパスワードは英大文字、英小文字、数字を組み合わせた8文字以上64文字以内で設定してください。')
            $('#password').addClass('error')
          }
          isValid = false
        } else {
          if (index === -1 || index === 0) {
            $('#password_error').html('')
            $('#password').removeClass('error')
          }
        }
      } else {
        // if newPassword is not input
        if (index === -1 || index === 0) {
          $('#password_error').html('')
          $('#password').removeClass('error')
        }
      }
      if ((this.credentials.newPassword !== null && this.credentials.newPassword !== '') &&
          (this.credentials.rePassword === null || this.credentials.rePassword === '')) {
        if (index === -1 || index === 1) {
          $('#repassword_error').html('新しいパスワード再入力は必須です。')
          $('#repassword').addClass('error')
        }
        isValid = false
      } else if (this.credentials.newPassword !== this.credentials.rePassword) {
        if (index === -1 || index === 0 || index === 1) {
          $('#repassword_error').html('「新しいパスワード」と一致しません。')
          $('#repassword').addClass('error')
        }
        isValid = false
      } else {
        if (index === -1 || index === 0 || index === 1) {
          $('#repassword_error').html('')
          $('#repassword').removeClass('error')
        }
      }
      if (this.userInfor.name === null || this.userInfor.name.trim() === '') {
        // ユーザー名（登録名）is required
        if (index === -1 || index === 2) {
          $('#name_error').html('ユーザー名（登録名）は必須です。')
          $('#name').addClass('error')
        }
        isValid = false
      } else {
        if (this.userInfor.name.length > 64) {
          // ユーザー名（登録名） > 64 chars
          if (index === -1 || index === 2) {
            $('#name_error').html('ユーザー名（登録名）は64文字以内で入力してください。')
            $('#name').addClass('error')
          }
          isValid = false
        } else {
          if (index === -1 || index === 2) {
            $('#name_error').html('')
            $('#name').removeClass('error')
          }
        }
      }
      if (this.userInfor.furigana !== null && this.userInfor.furigana !== '') {
        if (this.userInfor.furigana.length > 64) {
          if (index === -1 || index === 3) {
            $('#furigana_error').html('ユーザー名（ふりがな）は64文字以内で入力してください。')
            $('#furigana').addClass('error')
          }
          isValid = false
        } else {
          if (index === -1 || index === 3) {
            $('#furigana_error').html('')
            $('#furigana').removeClass('error')
          }
        }
      } else {
        // if furigana is not input
        if (index === -1 || index === 3) {
          $('#furigana_error').html('')
          $('#furigana').removeClass('error')
        }
      }
      if (this.userInfor.email !== null && this.userInfor.email !== '') {
        if (!this.userInfor.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/)) {
          if (index === -1 || index === 4) {
            $('#mailaddress_error').html('正しいメールアドレスを入力してください。')
            $('#mailaddress').addClass('error')
          }
          isValid = false
        } else {
          if (index === -1 || index === 4) {
            $('#mailaddress_error').html('')
            $('#mailaddress').removeClass('error')
          }
        }
      } else {
        // if email is not input
        if (index === -1 || index === 4) {
          $('#mailaddress_error').html('')
          $('#mailaddress').removeClass('error')
        }
      }
      if (this.userInfor.passCode !== null && this.userInfor.passCode !== '') {
        if (!this.userInfor.passCode.match(/^\d{4}$/)) {
          if (index === -1 || index === 5) {
            $('#passcode_error').html('暗証番号は半角数字で4文字入力してください。')
            $('#passcode').addClass('error')
          }
          isValid = false
        } else {
          if (index === -1 || index === 5) {
            $('#passcode_error').html('')
            $('#passcode').removeClass('error')
          }
        }
      } else {
        // if passCode is not input
        if (index === -1 || index === 5) {
          $('#passcode_error').html('')
          $('#passcode').removeClass('error')
        }
      }
      if (this.userInfor.option1 !== null && this.userInfor.option1 !== '') {
        if (this.userInfor.option1.length > 64) {
          if (index === -1 || index === 6) {
            $('#option1_error').html('備考は64文字以内で入力してください。')
            $('#option1').addClass('error')
          }
          isValid = false
        } else {
          if (index === -1 || index === 6) {
            $('#option1_error').html('')
            $('#option1').removeClass('error')
          }
        }
      } else {
        // if option 1 is not input
        if (index === -1 || index === 6) {
          $('#option1_error').html('')
          $('#option1').removeClass('error')
        }
      }
      if (this.userInfor.option2 !== null && this.userInfor.option2 !== '') {
        if (this.userInfor.option2.length > 64) {
          if (index === -1 || index === 7) {
            $('#option2_error').html('備考は64文字以内で入力してください。')
            $('#option2').addClass('error')
          }
          isValid = false
        } else {
          if (index === -1 || index === 7) {
            $('#option2_error').html('')
            $('#option2').removeClass('error')
          }
        }
      } else {
        // if option 2 is not input
        if (index === -1 || index === 7) {
          $('#option2_error').html('')
          $('#option2').removeClass('error')
        }
      }
      if (this.userInfor.phoneNumber !== null && this.userInfor.phoneNumber.trim() !== '') {
        if (!this.userInfor.phoneNumber.match(/^[0][0-9]{10}$/)) {
          if (index === -1 || index === 8) {
            $('#phonenumber_error').html('入力された電話番号は無効です。<br> 0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。')
            $('#phonenumber').addClass('error')
          }
          isValid = false
        } else {
          if (index === -1 || index === 8) {
            $('#phonenumber_error').html('')
            $('#phonenumber').removeClass('error')
          }
        }
      } else {
        if (index === -1 || index === 8) {
          if (!this.userInfor.isMfaSms) {
            $('#phonenumber_error').html('')
            $('#phonenumber').removeClass('error')
          } else {
            isValid = false
            $('#phonenumber_error').html('入力された電話番号は無効です。<br> 0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。')
            $('#phonenumber').addClass('error')
          }
        }
      }

      // if (document.getElementById('file_user_avatar').files.length > 0) {
      if (vm.fileTmp !== null && vm.fileTmp !== '') {
        var fileimg = vm.fileTmp
        // var fileimg = document.querySelector('input[type="file"]').files[0]
        if (this.imgWidth > 150 || this.imgHeight > 150) {
          // width or height > 150
          if (index === -1 || index === 8) {
            this.errorMessageLogs = '登録できる画像は、「ファイル形式：png、縦150×横150、ファイルサイズは64kバイト」となります。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
          // isValid = false
          this.message = ''
        } else if (fileimg.type !== 'image/png') {
          // type is not image/png
          if (index === -1 || index === 8) {
            this.errorMessageLogs = '登録できる画像は、「ファイル形式：png、縦150×横150、ファイルサイズは64kバイト」となります。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
          // isValid = false
          this.message = ''
        } else if (fileimg.size > 65536) {
          // size > 65536
          if (index === -1 || index === 8) {
            this.errorMessageLogs = '登録できる画像は、「ファイル形式：png、縦150×横150、ファイルサイズは64kバイト」となります。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
          // isValid = false
          this.message = ''
        } else {
          if (index === -1 || index === 8) {
            this.errorMessageLogs = ''
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
            this.getBase64(vm.fileTmp)
            vm.converImgtpBase64(vm.fileTmp)
          }
        }
      }
      return isValid
      // this.isEnabledSave = isValid
    },
    submitEditUser () {
      var isValid = this.validateBeforeSubmit(-1)
      if (isValid === true) {
        if (this.userInfor.email !== null && this.userInfor.email !== '') {
          $('#xacnhan').click()
        } else {
          this.anwser = true
        }
        if (this.anwser) {
          this.loading = true
          if (this.credentials.newPassword !== null && this.credentials.newPassword !== '') {
            this.changePassword(this.userInfor.userId)
          } else {
            this.editUser()
          }
        }
      }
    },
    changePassword (userId) {
      var vm = this
      this.errorMessageLogs = ''
      this.message = ''
      const credentials = {
        userId: userId,
        newPassword: this.credentials.newPassword,
        isSendEmail: this.userInfor.isSendEmail
      }
      console.log(credentials)
      this.$http.post(Config.USER_CHANGE_PASSWORD_API, JSON.stringify(credentials))
        .then(response => {
          vm.editUser()
          console.log(response)
        })
        .catch((error) => {
          this.loading = false
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessageLogs = ''
              } else {
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    editUser () {
      this.anwser = false
      this.errorMessageLogs = ''
      this.message = ''
      const encodedUserId = encodeURIComponent(encodeURIComponent(this.userInfor.userId))
      if (localStorage.userProfileId === this.userInfor.userId) {
        var OuserInforSelft = {}
        OuserInforSelft.name = this.userInfor.name
        OuserInforSelft.furigana = this.userInfor.furigana
        OuserInforSelft.email = this.userInfor.email
        OuserInforSelft.isSendEmail = this.userInfor.isSendEmail
        if (this.userInfor.thumbnail !== null && this.userInfor.thumbnail !== '') {
          OuserInforSelft.thumbnail = this.userInfor.thumbnail
        }
        OuserInforSelft.passCode = this.userInfor.passCode
        OuserInforSelft.isMfaSms = this.userInfor.isMfaSms
        if (this.userInfor.isMfaSms === true) {
          var phoneSelft = this.userInfor.phoneNumber.substring(1)
          OuserInforSelft.phoneNumber = '+81' + phoneSelft
        }
        OuserInforSelft.option1 = this.userInfor.option1
        OuserInforSelft.option2 = this.userInfor.option2
        console.log(OuserInforSelft)
        this.$http.put(Config.USERS_LIST_API + '/' + encodedUserId, JSON.stringify(OuserInforSelft))
          .then(response => {
            this.loading = false
            this.message = Config.EDIT_USER_API_SUCCESS
          })
          .catch((error) => {
            this.loading = false
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  this.errorMessageLogs = ''
                } else {
                  this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
              case 404:
                this.errorMessageLogs = '該当するデーターがありません。'
                break
              case 500:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      } else {
        var OuserInfor = {}
        OuserInfor.name = this.userInfor.name
        OuserInfor.furigana = this.userInfor.furigana
        OuserInfor.isSendEmail = this.userInfor.isSendEmail
        OuserInfor.email = this.userInfor.email
        if (this.userInfor.thumbnail !== null && this.userInfor.thumbnail !== '') {
          OuserInfor.thumbnail = this.userInfor.thumbnail
        }
        OuserInfor.passCode = this.userInfor.passCode
        OuserInfor.isMfaSms = this.userInfor.isMfaSms
        if (this.userInfor.isMfaSms === true) {
          var phone = this.userInfor.phoneNumber.substring(1)
          OuserInfor.phoneNumber = '+81' + phone
        }
        OuserInfor.isAdmin = this.userInfor.isAdmin
        OuserInfor.isPhoneAdmin = this.userInfor.isPhoneAdmin
        OuserInfor.shareKeyBeValid = this.userInfor.shareKeyBeValid
        OuserInfor.isValid = this.userInfor.isValid
        OuserInfor.option1 = this.userInfor.option1
        OuserInfor.option2 = this.userInfor.option2
        console.log(OuserInfor)
        this.$http.put(Config.USERS_LIST_API + '/' + encodedUserId, JSON.stringify(OuserInfor))
          .then(response => {
            this.loading = false
            this.message = Config.EDIT_USER_API_SUCCESS
          })
          .catch((error) => {
            this.loading = false
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  this.errorMessageLogs = ''
                } else {
                  this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
              case 404:
                this.errorMessageLogs = '該当するデーターがありません。'
                break
              case 500:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      }
    }
  }
}
</script>

<style type="text/css">
.red {
  color:red;
}
.float-left{
  float: left;
  padding-left: 12px
}
.btn-cus{
  padding: 10px 15px;
  border-radius: 10px;
  color: #fff
}
.btn-right{
  float: right;
}
.btn-add,.btn-add:hover{
  background: #007F41!important
}
a.btn-delete,a.btn-delete:hover{
  background: #000!important;
  border-color: #000!important;
  color: #fff!important;
  margin-right: 10px;
  text-decoration: none;
}
.profile-info-value>span+span:before {
    display: inline;
    content: "|";
    padding: 0 15px;
    margin-left: 1px;
    margin-right: 3px;
    color: #666;
    border-bottom: 1px solid #FFF;
}
#error-alert, #success-alert {
  display: none;
}
textarea.error {
  border:1px solid red;
}
span.error_m {
  font-size: 15px;
  font-weight: normal;
  color: #FF4040;
  display: block;
  margin: 0;
}
.cusrow{
  padding: 6px 4px 6px 6px;
  width: 95%;
  margin-right: 10px;
  border-top: 1px dotted #D5E4F1;
}
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .register_user .profile-info-name{
    text-align: left;
    width: 225px
  }
  .userav input[type=file] {
    margin: 0 auto
  }
  span.error {
  color: red;
}
input.error {
  border: 1px solid red;
}
.profile-info-row .cusrow{width: 65%}
.lblPassword{width: 160px;display: inline-block;}
@media only screen and (max-width: 1300px){
  #user_avatar {
    width: 100% !important;
    height: auto !important
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserEdit.vue